import { useState, useEffect } from 'react'
import Head from 'next/head'
import styles from "../../styles/pages/Blogs.module.scss"
import Link from 'next/link'
import Topbanner from '../../components/Topbanner/Topbanner'
import { blogsData } from '../../data/blogsData'
import Image from 'next/image'
export const getStaticProps = async () => {
    return {
        props: {
            Allblogs: blogsData,
        }
    }
}

export default function Blogs({ Allblogs }) {
    const [isSSR, setIsSSR] = useState(true);

    useEffect(() => {
        setIsSSR(false);
    }, []);

    return (
        <>
            <Head>
                <title>The Twin Towers Hotel in Kufri, Shimla Blog - Insights, Tips, and Travel blog</title>
                <meta name="description" content="Click on the link and read blogs about The Twin Towers Hotel, discover its activities, and learn more about the surrounding area." />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/blogs" />
            </Head>
            <Topbanner bgImage={"/images/contact-banner.png"} title={"Our Blogs"} />
            {/* <section className={`${styles.blogs} common_padding`}>
                <div className='container'>
                    <div className={`${styles.blog_top} row align-items-center`}>
                        <div className={`${styles.blog_top_img} col-md-6`}>
                            <img src="/images/blog-img.jpg" />
                        </div>
                        <div className='col-md-6 common_title'>
                            <p>Hotel in Kufri</p> <span>20 Oct, 2022</span>
                            <h2>Lorem ipsum dolor sitamet consectetur</h2>
                            <p>The Super Deluxe rooms offers that luxury and comfort to our guests. The Super deluxe hotel room is finely decorated for your luxurious stay and contains all basic amenities such as Color LCD with Cable, Large windows for the perfect valley views, cozy double bed with quality material, Resting chair, Dressing mirror, Mini Fridge and 24 hrs running hot.</p>
                        </div>
                    </div>
               
                </div>
            </section> */}
            <section className={`${styles.blogs} common_padding`}>
                <div className='container'>
                    <div className={`${styles.blog_bottom} `}>
                        <h2 className='d-none'>The twin Towers Hotel Blogs</h2>

                        {Allblogs.slice(0, 1).map((blog) => (
                            <Link href={`/blogs/${blog.slug}`} className={`${styles.top_blog}`} key={blog.slug}>
                                {!isSSR &&
                                    <>
                                        <div className={styles.top_blog_image}>
                                            <Image src={blog.bgImage} fill={true} alt={blog.title}></Image>
                                        </div>
                                        <div className={`${styles.top_blog_content} d-flex`}>
                                            <div>
                                                <p className={styles.blog_date}>{blog.date}</p>
                                                <h4 className={styles.blog_title}>{blog.blog_title}</h4>
                                                <p>{blog.shortDescription}</p>
                                                <button className='common_btn'>Read More</button>
                                            </div>

                                        </div>
                                    </>
                                }
                            </Link>
                        ))}
                        <div className={`${styles.all_blogs} common_padding`}>
                            {Allblogs.slice(1).map((blog) => (
                                <Link href={`/blogs/${blog.slug}`} className={`${styles.single_blog_parent}`} key={blog.slug}>
                                    {!isSSR &&
                                        <>
                                            <div className={styles.all_blog_image}>
                                                <Image src={blog.bgImage} fill={true}></Image>
                                            </div>
                                            <div className={`${styles.all_blog_content} d-flex`}>
                                                <div>
                                                    <p className={styles.blog_date}>{blog.date}</p>
                                                    <h4 className={styles.blog_title}>{blog.blog_title}</h4>
                                                    <p>{blog.shortDescription}</p>
                                                    {/* <button className='common_btn'>Read More</button> */}
                                                </div>

                                            </div>
                                        </>
                                    }
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
